import { createStore } from 'vuex'

import pcc from './modules/pcc'
import stagehand from './modules/stagehand'
import station from './modules/station'
import stories from './modules/stories'
import storyHub from './modules/storyHub'
import tasks from './modules/tasks'
import user from './modules/user'
import roles from './modules/roles'
import mediaAssets from './modules/mediaAssets'
import shareRequests from './modules/shareRequests'
import options from './modules/options'
import notifications from './modules/notifications'
import oneSignal from './modules/oneSignal'
import modal from './modules/modal'
import viewPresets from './modules/viewPresets'
import websocket from './modules/websocket'
import aiAgentChat from './modules/aiAgentChat'
import sequences from './modules/sequences'
import api from '@/api'

export default createStore({
  modules: {
    pcc,
    stagehand,
    station,
    stories,
    storyHub,
    tasks,
    user,
    roles,
    mediaAssets,
    shareRequests,
    options,
    notifications,
    oneSignal,
    modal,
    viewPresets,
    websocket,
    aiAgentChat,
    sequences
  },
  state: {
    unsavedChanges: false,
    apiVersion: ''
  },
  mutations: {
    SET_UNSAVED_CHANGES(state, unsavedChanges) {
      state.unsavedChanges = unsavedChanges
    },
    SET_API_VERSION(state, apiVersion) {
      state.apiVersion = apiVersion
    }
  },
  actions: {
    setUnsavedChanges({ commit }, unsavedChanges) {
      commit('SET_UNSAVED_CHANGES', unsavedChanges)
    },
    async loadApiVersion({ commit }) {
      const response = await api.newsdesk.getServerInfo()
      const apiVersion = response?.data?.server?.version ?? ''
      commit('SET_API_VERSION', apiVersion)
    }
  },
  getters: {
    unsavedChanges(state, getters, rootState) {
      return state.unsavedChanges || rootState?.sequences?.sequenceUnsavedChanges
    },
    apiVersion(state) {
      return state.apiVersion
    }
  }
})
